import * as React from "react";
import { IconProps } from "./types";

export const BarChart04Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 11L3 21M15 11L15 21M9 3L9 21M21 3V21"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(BarChart04Icon as React.FunctionComponent).displayName = "BarChart04Icon";

export default BarChart04Icon;
